export const countNumberOfBreakLines = (text?: string) => {
  return text?.match(/\n|↵/g)?.length || 0
}

export const replaceBreakLineCharsWithPhraseeBreakSymbol = (text: string) => {
  // \r\n must be listed before \r and \n so the two-char sequence is matched
  // as one unit instead of two separate replacements
  return text?.replace(/(?:\r\n|\r|\n)/g, '〽')
}
